class InfiniteProductGrid extends HTMLElement {
  constructor() {
    super();
    this.loading = false

    const onScrollHandler = this.onScrollHandler;
    window.addEventListener('scroll', onScrollHandler.bind(this));

    // const debouncedOnScroll = debounce((event) => {
    //   this.onScrollHandler(event);
    // }, 50);
    // window.addEventListener('scroll', debouncedOnScroll.bind(this));
  }

  onScrollHandler() {
    const pagination = this.querySelector('.pagination-wrapper')
    if( pagination === null) {
      return;
    }
    if (
      window.innerHeight + window.scrollY >= pagination.offsetTop &&
      this.loading === false
    ) {
      this.loadMoreProducts();
    }
  }

  loadMoreProducts() {
    const pagination = this.querySelector('.pagination-wrapper')
    if( pagination === null) {
      return;
    }
    this.loading = true;
    const paginationUrl = pagination.querySelector('.pagination__item--current')?.closest('li')?.nextElementSibling?.querySelector('a')?.getAttribute('href')
    const fetchUrl = (paginationUrl.indexOf('?') > -1) ? `${paginationUrl}&sections=main-collection-product-grid` : `${paginationUrl}?sections=main-collection-product-grid`
    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteProductGrid.renderProductGrid(JSON.parse(html)['main-collection-product-grid']);
      });
  }

  static renderProductGrid(html) {
    const infiniteProductGrid = document.querySelector('infinite-product-grid');
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const productGrid = infiniteProductGrid.querySelector('#product-grid');
    infiniteProductGrid.querySelector('.pagination-wrapper').innerHTML = parsedHTML.querySelector('.pagination-wrapper').innerHTML;

    const fetchedProductGrid = parsedHTML.querySelector('#product-grid')
    fetchedProductGrid.querySelectorAll('.scroll-trigger').forEach((ele) => {
      ele.classList.remove('scroll-trigger');
    });
    productGrid.innerHTML = productGrid.innerHTML + fetchedProductGrid.innerHTML;
    infiniteProductGrid.loading = false;
  }
}

customElements.define('infinite-product-grid', InfiniteProductGrid);